<template>
  <div class="navbar">
    <div class="navtext" @click="$_handlerClickJump('/')">
      <P>杭州图景网络技术有限公司</P>
    </div>
    <ul class="ul">
      <li class="li" v-for="(item, index) in list" :key="index" @click="$_handlerClickJump(item, index)" :class="isCheckFn(item) ? 'checked' : ''">
        <div class="li-text">
          {{ item.name }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'navbar',
  data() {
    return {
      num: '',
      type: false,
      index: 0,
      checkIndex: 0,
      list: [
        {
          name: '首页',
          route: '/'
        },
        {
          name: '地图能力',
          route: '/ability'
        },
        {
          name: '解决方案',
          route: '/solve',
          chirld: 'city'
        },
        {
          name: '客户案例',
          route: '/case'
        },
        {
          name: '关于我们',
          route: '/about'
        }
      ]
    };
  },
  computed: {
    route() {
      return this.$route.path;
    }
  },
  methods: {
    // 跳转路由
    $_handlerClickJump(item, index) {
      // const { route, chirld } = item;
      const { route } = item;
      let { fullPath } = this.$route;
      if (!route) {
        return;
      }
      if (fullPath === route) {
        return;
      }
      this.$router.push({
        path: item.route
      });
      document.documentElement.scrollTop = 0;
    },
    // 判断路由是否被选中
    isCheckFn(item) {
      // const {
      //   path,
      //   meta: { title }
      // } = this.$route;
      const { path } = this.$route;
      const { name, route } = item;
      // 判断首页
      if (path === route) {
        return true;
      }
      return path.includes(route) && name !== '首页';
    }
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
@import url('~@/icons/pingfang/font.css');
.navbar {
  position: fixed;
  top: 0;
  width: 100vw;
  min-width: 1226px;
  height: 52px;
  background-color: #282828;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-family: 'PingFang';
  z-index: 100;
  .navtext {
    height: 100%;
    display: flex;
    align-items: center;
    p {
      font-size: 22px;
      color: #e5e5e5;
      cursor: pointer;
    }
  }
  .ul {
    height: 100%;
    display: flex;
    .li {
      cursor: pointer;
      position: relative;
      padding: 0 10px;
      font-size: 16px;
      color: #e5e5e5;
      line-height: 50px;
      margin: 0 10px;
      letter-spacing: 1px;
      &:hover {
        &::before {
          width: 100%;
        }
        .li-text {
          color: #f15030;
        }
      }
      &::before {
        content: '';
        position: absolute;
        left: 50%;
        bottom: 0;
        height: 3px;
        background: #f15030;
        width: 0;
        transition: 0.3s linear;
        transform: translateX(-50%);
      }
    }
    .checked {
      .li-text {
        color: #f15030;
      }
      &::before {
        width: 100%;
      }
    }
  }
}
</style>
